<template>
  <div class="ProjectOverview">
    <!-- 导航区域 -->
    <div
      style="
        height: 40px;
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;

        position: relative;
      "
    >
      <div style="margin-right: 10px">
        <el-button type="primary" @click="$router.go(-1)"
          ><i class="el-icon-back" style="margin-right: 10px"></i>
          后退前页</el-button
        >
      </div>
      <div style="color: #000">
        <span
          style="cursor: pointer"
          @click="$router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)"
          >{{ backName || '工作台' }}</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #606266" class="ellipsis">{{ title }}</div>

      <el-button
        class="exportpdf"
        type="primary"
        @click="exportPDF()"
        icon="el-icon-download"
        >导出总览</el-button
      >
    </div>
    <div class="centent">
      <!-- //顶部区域 -->
      <div class="top-area" v-loading="loading">
        <el-row class="wh100" :gutter="5">
          <el-col :span="4">
            <el-card>
              <div class="echarts-tit">提交率</div>
              <div style="width: 100%; height: 150px" id="DeviceProgress"></div>
            </el-card>
          </el-col>
          <el-col :span="4"
            ><el-card>
              <div class="echarts-tit">通过率</div>
              <div
                style="width: 100%; height: 150px"
                id="DocumentProgress"
              ></div
            ></el-card>
          </el-col>
          <el-col :span="16">
            <div class="stats-grid">
              <div
                class="stat-item-wrapper"
                v-for="(item, index) in statsData"
                :key="index"
              >
                <el-card class="stat-card mini" :class="getStatCardClass()">
                  <div class="stat-item">
                    <div class="stat-content">
                      <div class="stat-label">{{ item.label }}</div>
                      <div class="stat-value">{{ item.value }}</div>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- tabs区域 -->
      <div class="tabs-area">
        <el-card>
          <el-button
            class="exportword"
            type="primary"
            @click="exportWord"
            icon="el-icon-download"
            v-if="!isloadingPdf"
            >导出数据</el-button
          >
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane
              v-for="item in tabsData"
              :key="item.value"
              :label="item.name"
              :name="item.value"
            >
              <Overview
                ref="Overview"
                v-if="item.value === '总览' && activeName === '总览'"
                :pId="pId"
              ></Overview>
              <DeviceView
                ref="DeviceView"
                v-if="item.value === '设备统计' && activeName === '设备统计'"
                :pId="pId"
                :isloadingPdf="isloadingPdf"
              ></DeviceView>
              <SupplierView
                ref="SupplierView"
                v-if="
                  item.value === '供应商统计' && activeName === '供应商统计'
                "
                :pId="pId"
              ></SupplierView>

              <DeviceInventoryList
                ref="DeviceInventoryList"
                v-if="item.value === '设备清单' && activeName === '设备清单'"
                :pId="pId"
              ></DeviceInventoryList>
              <DeviceDocumentList
                ref="DeviceDocumentList"
                v-if="
                  item.value === '设备资料清单' && activeName === '设备资料清单'
                "
                :pId="pId"
              ></DeviceDocumentList>
              <SpareInventoryList
                ref="SpareInventoryList"
                v-if="item.value === '配件清单' && activeName === '配件清单'"
                :pId="pId"
              ></SpareInventoryList>
              <CertificationInventoryList
                ref="CertificationInventoryList"
                v-if="item.value === '资质清单' && activeName === '资质清单'"
                :pId="pId"
              ></CertificationInventoryList>
              <ProjectInventoryList
                ref="ProjectInventoryList"
                v-if="
                  item.value === '项目资料清单' && activeName === '项目资料清单'
                "
                :pId="pId"
              ></ProjectInventoryList>

              <SupplierInventoryList
                ref="SupplierInventoryList"
                v-if="
                  item.value === '供应商通讯录' && activeName === '供应商通讯录'
                "
                :pId="pId"
              ></SupplierInventoryList>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import Overview from './Overview.vue'
import DeviceView from './DeviceView.vue'
import SupplierView from './SupplierView.vue'
import DeviceInventoryList from './DeviceInventoryList.vue'
import SpareInventoryList from './SpareInventoryList.vue'
import DeviceDocumentList from './DeviceDocumentList.vue'
import SupplierInventoryList from './SupplierInventoryList.vue'
import CertificationInventoryList from './CertificationInventoryList.vue'
import ProjectInventoryList from './ProjectInventoryList.vue'
import utils from '@/utils/utils.js'

export default {
  data() {
    return {
      isloadingPdf: false,
      pId: '',
      activeName: '',
      backName: '',
      title: '',
      loading: false,
      statDataInfo: {},
      statsData: [],
      tabsData: [
        { name: '总览', value: '总览' },
        { name: '设备统计', value: '设备统计' },
        { name: '供应商统计', value: '供应商统计' },
        { name: '设备清单', value: '设备清单' },
        { name: '设备资料清单', value: '设备资料清单' },
        { name: '配件清单', value: '配件清单' },
        { name: '资质清单', value: '资质清单' },
        { name: '项目资料清单', value: '项目资料清单' },
        { name: '供应商通讯录', value: '供应商通讯录' },
      ],
    }
  },
  props: {},
  components: {
    Overview,
    DeviceView,
    SupplierView,
    DeviceInventoryList,
    SpareInventoryList,
    DeviceDocumentList,
    SupplierInventoryList,
    CertificationInventoryList,
    ProjectInventoryList,
  },
  methods: {
    exportWord() {
      if (this.activeName === '总览') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportTotalStatisticToExcel?ProjectId=${this.pId}`,
          '总览',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '设备统计') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportDeviceStatisticToExcel?ProjectId=${this.pId}`,
          '设备统计',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '供应商统计') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportPropertyProjectSupplierStatisticsInputOutToExcel?ProjectId=${this.pId}`,
          '供应商统计',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '设备清单') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportProjectDeviceStatisticsInputOutToExcel?ProjectId=${this.pId}`,
          '设备清单',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '配件清单') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportDeviceAccessoryToExcel?ProjectId=${this.pId}`,
          '配件清单',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '资质清单') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportSupplierTypeFilesToExcel?ProjectId=${this.pId}`,
          '资质清单',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '项目资料清单') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportSupplierFilesToExcel?ProjectId=${this.pId}`,
          '项目资料清单',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '设备资料清单') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_Project/ExportDeviceInforToExcel?ProjectId=${this.pId}`,
          '设备资料清单',
          '.xlsx',
          'get'
        )
      } else if (this.activeName === '供应商通讯录') {
        utils.download(
          this.$rootUrl +
            `/Base_ProjectWork/Base_ProjectSupplier/ExportVenToExcel?ProjectId=${this.pId}`,
          '供应商通讯录',
          '.xlsx',
          'get'
        )
      }
    },
    resetChartsData() {
      this.$nextTick(() => {
        for (let index = 0; index < 2; index++) {
          var chartDom = document.getElementById(
            index == 0 ? 'DeviceProgress' : 'DocumentProgress'
          )
          if (!chartDom) continue

          var myChart = echarts.init(chartDom)
          var option = {
            tooltip: {
              appendToBody: true,
              formatter: '{a} : {c}%',
            },
            series: [
              {
                name: index == 0 ? '提交率' : '通过率',
                type: 'gauge',
                startAngle: 180,
                endAngle: 360,
                min: 0,
                max: 100,
                splitNumber: 10,
                radius: '90%',
                center: ['50%', '50%'],
                progress: {
                  show: true,
                  width: 6,
                  itemStyle: {
                    color: index == 0 ? '#409eff' : '#67C23A',
                  },
                  roundCap: true,
                },
                axisLine: {
                  lineStyle: {
                    width: 6,
                  },
                },
                axisTick: {
                  show: true,
                  distance: 1,
                  length: 3,
                  lineStyle: {
                    width: 1,
                    color: '#999',
                  },
                },
                splitLine: {
                  distance: 1,
                  show: true,
                  length: 5,
                  lineStyle: {
                    width: 2,
                    color: '#999',
                  },
                },
                axisLabel: {
                  distance: 8,
                  color: '#999',
                  fontSize: 10,
                },
                pointer: {
                  width: 3,
                  length: '70%',
                  itemStyle: {
                    color: index == 0 ? '#409eff' : '#67C23A',
                  },
                },
                detail: {
                  formatter: '{value}%',
                  textStyle: {
                    fontSize: 14,
                    color: '#333',
                    fontWeight: 'bold',
                  },
                  offsetCenter: [0, 15],
                },
                data: [
                  {
                    value:
                      index == 0
                        ? this.statDataInfo.SubmissionRate || 0
                        : this.statDataInfo.PassRate || 0,
                  },
                ],
              },
            ],
          }

          option && myChart.setOption(option)
          myChart.resize()
        }
      })
    },
    //获取头部总数据
    getStatData() {
      this.loading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetProjectTStatistic', {
          Search: {
            ProjectId: this.pId,
          },
        })
        .then((res) => {
          console.log('获取头部总数据', res)
          if (res.Success) {
            this.statDataInfo = res.Data
            this.statsData = [
              {
                label: '乙供数量',
                value: this.statDataInfo.GeneralContractorQty || 0,
              },
              // {
              //   label: '代理数量',
              //   value: this.statDataInfo.ASupplyQty || 0,
              // },
              {
                label: '甲供数量',
                value: this.statDataInfo.DSupplyQty || 0,
              },
              {
                label: '分包商数量',
                value: this.statDataInfo.SubcontractorsQty || 0,
              },

              { label: '设备数量', value: this.statDataInfo.DevicesQty || 0 },
              // {
              //   label: '部件数量',
              //   value: this.statDataInfo.ComponentsQty || 0,
              // },

              { label: '资料数量', value: this.statDataInfo.InforQty || 0 },
              {
                label: '专用配件',
                value: this.statDataInfo.zPartsQty || 0,
              },
              {
                label: '通用配件',
                value: this.statDataInfo.tPartsQty || 0,
              },
              { label: '提交数量', value: this.statDataInfo.RejectedQty || 0 },
              { label: '驳回数量', value: this.statDataInfo.NotPassQty || 0 },
              { label: '通过数量', value: this.statDataInfo.PassQty || 0 },
            ]
            this.$nextTick(() => {
              this.resetChartsData()
            })
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取统计卡片样式类
    getStatCardClass() {
      // 统一使用主色调，不再区分不同颜色
      return 'stat-primary'
    },

    // 导出PDF方法
    async exportPDF() {
      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.isloadingPdf = true
      try {
        const result = await utils.exportToPDF(
          '.centent',
          `项目统计_${this.activeName}_${utils.formatDate('day')}`,
          {
            scale: 3, // 提高缩放比例以增加清晰度
            padding: 2, // PDF内边距15mm
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
          }
        )
        loading.close()
        this.isloadingPdf = false
        if (result.success) {
          this.$notify.success(`导出PDF成功`)
        } else {
          this.$notify.error(result.message)
        }
      } catch (error) {
        this.isloadingPdf = false
        loading.close()
        console.error('导出PDF失败:', error)
        this.$notify.error('导出PDF失败，请重试')
      }
    },
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.getStatData()
  },
  computed: {},
  watch: {
    $route: {
      handler() {
        this.activeName = '总览'
        this.title = '项目统计'
        this.backName = window.localStorage.getItem('ProjectName') || ''
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.ProjectOverview {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  overflow-y: auto;
  ::v-deep .el-card {
    width: 100%;
    height: 100%;
  }
  ::v-deep .el-card__body {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  ::v-deep .el-col {
    height: 100%;
  }

  .top-area {
    width: 100%;
    height: 150px;

    .stats-grid {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .stat-item-wrapper {
        width: calc(20% - 6.4px); // 每行5个，减去gap的影响
        height: calc(50% - 4px); // 两行，减去gap的影响
      }

      .stat-card {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        // border-left: 4px solid #409eff;

        &.mini {
          ::v-deep .el-card__body {
            padding: 8px 12px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        // 统一使用主色调
        .stat-value {
          color: #409eff;
        }
      }

      .stat-item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .stat-content {
          text-align: center;

          .stat-label {
            font-size: 18px;
            font-weight: bold;
            color: #666;
            margin-bottom: 10px;
            line-height: 1;
          }

          .stat-value {
            font-size: 18px;
            font-weight: bold;
            line-height: 1;
            color: #409eff;
          }
        }
      }
    }
  }

  .tabs-area {
    width: 100%;

    margin-top: 10px;
    position: relative;
    // ::v-deep .el-tabs {
    //   width: 100%;
    //   height: 100%;
    // }
    // ::v-deep .el-tabs__header {
    // }
    // ::v-deep .el-tabs__content {
    //   width: 100%;
    //   height: calc(100% - 55px);
    //   overflow-y: auto;
    //   padding: 0 10px;
    // }
  }
}
.echarts-tit {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}
.exportpdf {
  position: absolute;
  width: 90px;
  right: 30px;
  top: 5px;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
}
.exportword {
  position: absolute;
  width: 90px;
  right: 30px;
  top: 5px;
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
